<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col cols="12" md="6">
            <div>
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="text-color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields.textColor"
                  @change="handleChangeTextColor"
                />
                <v-text-field v-model="fields.textColor" label="Text Color" :hide-details="true" />
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div>
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="bg"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['background-section'].color"
                  @change="handleChangeCardContainer"
                />
                <v-text-field
                  v-model="fields['background-section'].color"
                  label="Background Color"
                  :hide-details="true"
                />
              </div>
            </div>
          </v-col>
        </v-row>

        <div class="mb-6 mt-6">
          <label class="label-input">Padding</label>
          <div class="group-item">
            <v-row>
              <v-col md="6" cols="12">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.top" label="Top Padding" />
                </div>
              </v-col>
              <v-col md="6" cols="12">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-6">
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <label :for="`showRating-multi-tool`" style="margin-bottom: 0" class="label-input">Rating</label>
            <input type="checkbox" v-model="fields.reted.showRating" :id="`showRating-multi-tool`" />
          </div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-rating
                  color="warning"
                  background-color="#c1c1c1"
                  empty-icon="mdi-star-outline"
                  full-icon="mdi-star"
                  half-icon="mdi-star-half-full"
                  hover
                  length="5"
                  size="35"
                  :value="fields.reted.ratingStars"
                  @input="handleChangeRatingStars"
                ></v-rating>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field v-model="fields.reted.ratingText" label="Text" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields.reted.showRating" label="Show Rating" />
              </v-col>
              <v-col cols="12" md="8">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="rating-text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.reted.ratingTextColor"
                    @change="handleChangeRatingTextColor"
                  />
                  <v-text-field v-model="fields.reted.ratingTextColor" label="Rating Text Color" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div style="margin-bottom: 20px">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input">Content</label>
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <input type="checkbox" v-model="fields.leftCard.centerY" id="style-center-y" />
              <label for="style-center-y" style="margin-bottom: 0">Style center Y</label>
            </div>
          </div>
          <label class="">Content</label>
          <ckeditor :editor="editor" v-model="fields.cardContent" :config="editorConfig" />
        </div>
        <div class="mb-4">
          <label class="label-input">Container content</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields['container-content'].showStyle" label="Show style" />
              </v-col>
              <v-col cols="12" md="8">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['container-content'].background"
                    @change="e => (fields['container-content'].background = e.target.value)"
                  />
                  <v-text-field v-model="fields['container-content'].background" label="Container background" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Card border</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields.leftCard.enableBorder" label="Enable border" />
              </v-col>
              <v-col cols="12" md="8">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.leftCard.colorBorder"
                    @change="e => (fields.leftCard.colorBorder = e.target.value)"
                  />
                  <v-text-field v-model="fields.leftCard.colorBorder" label="Border color" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label :for="`showAccordions-multi-tool`" style="margin-bottom: 0" class="label-input">Accordions</label>
              <input
                type="checkbox"
                v-model="fields.itemAccordions.dataShowAccordion"
                :id="`showAccordions-multi-tool`"
              />
            </div>
            <v-btn small text color="primary" @click="handleAddAccordion">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Accordion</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields.itemAccordions.listItem" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Accordion {{ i + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveAccordion(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div>
                  <v-text-field v-model="item.title" label="Title" />
                  <ckeditor :editor="editor" v-model="item.answer" :config="editorConfig" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label :for="`showImgSmall-multi-tool`" style="margin-bottom: 0" class="label-input">Images Small</label>
              <input type="checkbox" v-model="fields['images-small'].show" :id="`showImgSmall-multi-tool`" />
            </div>
            <v-btn small text color="primary" @click="handleAddImageSmall">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Image</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-row>
              <v-col v-for="(item, i) in fields['images-small'].listItem" :key="i" cols="12" md="6">
                <div class="img-small-item-card">
                  <div class="img-small-item-actions">
                    <v-radio-group
                      row
                      dense
                      :value="item.mediaType || 'image'"
                      @change="val => handleChangeImageSmallMediaType(val, i)"
                    >
                      <v-radio label="Image" value="image" />
                      <v-radio label="Video" value="video" />
                    </v-radio-group>
                    <v-btn icon small class="img-small-delete" @click="handleRemoveImageSmall(i)">
                      <v-icon size="16" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>

                  <div v-if="(item.mediaType || 'image') === 'image'">
                    <UploadImage
                      @callback="obj => handleUploadImageSmall(obj, i)"
                      :image="{ imageSrc: item.img }"
                      :height="`100`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleClearImageSmallMedia(i)"
                    />
                  </div>
                  <div v-else>
                    <div class="d-flex align-center" style="gap: 8px">
                      <v-text-field
                        :value="item.video"
                        label="Video URL"
                        dense
                        hide-details
                        @input="val => handleUpdateImageSmallVideo(val, i)"
                      />
                      <v-btn icon small @click="handleRefreshImageSmallVideo(i)">
                        <v-icon size="18">mdi-refresh</v-icon>
                      </v-btn>
                    </div>
                    <div class="video-small-preview">
                      <video
                        v-if="item.video"
                        :key="`image-small-video-preview-${i}-${item.previewTick || 0}`"
                        width="100%"
                        height="auto"
                        controls
                        autoplay
                        muted
                        loop
                        playsinline
                      >
                        <source :src="item.video" type="video/mp4" />
                      </video>
                    </div>
                  </div>

                  <div class="mt-2">
                    <v-checkbox
                      dense
                      :input-value="item.showIcon !== false"
                      label="Hiển thị icon"
                      @change="val => handleToggleImageSmallIcon(val, i)"
                    />
                    <div v-if="item.showIcon !== false">
                      <UploadImage
                        @callback="obj => handleUploadImageSmallIcon(obj, i)"
                        :image="{ imageSrc: item.icon }"
                        :height="`80`"
                        :typeUpload="'image'"
                        @callbackDelete="() => handleRemoveImageSmallIcon(i)"
                      />
                    </div>
                  </div>
                  <div class="mt-2 d-flex justify-end">
                    <v-btn small outlined color="error" @click="handleRemoveImageSmall(i)">Xóa item</v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label :for="`showItemWithIcon-multi-tool`" style="margin-bottom: 0" class="label-input">
                Item With Icon
              </label>
              <input type="checkbox" v-model="fields.itemWithIcon.show" :id="`showItemWithIcon-multi-tool`" />
            </div>
            <v-btn small text color="primary" @click="handleAddItemWithIcon">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields.itemWithIcon.listItem" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Item {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItemWithIcon(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label class="label-input" style="font-size: 14px !important; margin-bottom: 6px">Icon</label>
                    <UploadImage
                      @callback="obj => handleUploadItemWithIcon(obj, i)"
                      :image="{ imageSrc: item.icon }"
                      :height="`100`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleRemoveItemWithIconIcon(i)"
                    />
                  </div>
                  <v-text-field v-model="item.title" label="Title" />
                  <v-text-field v-model="item.description" label="Description" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div>
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <label :for="`showBtn-multi-tool`" style="margin-bottom: 0" class="label-input">Button</label>
            <input type="checkbox" v-model="fields.btnCard.showBtn" :id="`showBtn-multi-tool`" />
          </div>
          <div class="group-item">
            <v-text-field v-model="fields.btnCard.text" label="Button Text" />
            <v-text-field v-model="fields.btnCard.url" label="Button URL" />
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="button-bg"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.btnCard.backgroundColor"
                    @change="handleChangeButtonBackground"
                  />
                  <v-text-field v-model="fields.btnCard.backgroundColor" label="Button Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="button-text"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.btnCard.color"
                    @change="handleChangeButtonTextColor"
                  />
                  <v-text-field v-model="fields.btnCard.color" label="Button Text Color" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mt-4">
          <label class="label-input">Media</label>
          <div class="group-item">
            <v-select
              :value="Number(fields.rightCard.order) === 1 ? 1 : 2"
              :items="postionOptions"
              label="Position"
              @change="handleChangePosition"
            />
            <v-radio-group row :value="fields.rightCard.mediaType || 'video'" @change="handleChangeMediaType">
              <v-radio label="Image" value="image" />
              <v-radio label="Video" value="video" />
            </v-radio-group>
            <div v-if="(fields.rightCard.mediaType || 'video') === 'image'">
              <UploadImage
                @callback="handleUploadRightCardImage"
                :image="{ imageSrc: fields.rightCard.img }"
                :height="`250`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveRightCardImage"
              />
            </div>
            <div v-else>
              <v-text-field
                :value="fields.rightCard.video"
                label="Right card video URL"
                @input="handleChangeRightCardVideo"
              />
              <div class="video-preview">
                <video v-if="fields.rightCard.video" width="100%" height="auto" autoplay muted loop playsinline>
                  <source :src="fields.rightCard.video" type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

export default {
  name: 'CardMultiTool',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      postionOptions: [
        { text: 'Left', value: 1 },
        { text: 'Right', value: 2 },
      ],
      fields: {
        title: 'Card Multi Tool Section',
        enableAnchor: false,
        textColor: '#000000',
        padding: { top: true, bottom: true },
        'background-section': { color: '#ffffff' },
        'container-content': { showStyle: false, background: '#ffffff' },
        leftCard: { order: '2', centerY: false, enableBorder: true, colorBorder: '#d4dceb' },
        rightCard: { order: '1', mediaType: 'video', img: '', video: '' },
        reted: { showRating: false, ratingStars: 4, ratingText: '', ratingTextColor: '#000000' },
        cardContent: '',
        itemAccordions: { dataShowAccordion: true, listItem: [] },
        'images-small': { show: true, listItem: [] },
        itemWithIcon: { show: true, listItem: [] },
        btnCard: {
          showBtn: true,
          backgroundColor: '#d4c4a8',
          color: '#ffffff',
          text: 'Learn more',
          url: '#',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
    const rightCard = {
      order: '1',
      mediaType: 'video',
      img: '',
      video: '',
      ...(this.fields.rightCard || {}),
    };
    if (!rightCard.mediaType) {
      rightCard.mediaType = rightCard.video ? 'video' : rightCard.img ? 'image' : 'video';
    }
    if (rightCard.mediaType === 'image') {
      rightCard.video = '';
    } else {
      rightCard.img = '';
    }
    this.fields.rightCard = rightCard;
    if (!this.fields['images-small']) {
      this.fields['images-small'] = { show: true, listItem: [] };
    }
    if (!Array.isArray(this.fields['images-small'].listItem)) {
      this.fields['images-small'].listItem = [];
    }
    this.fields['images-small'].listItem = this.fields['images-small'].listItem.map(item => {
      const mediaType = item?.mediaType === 'video' || item?.video ? 'video' : 'image';
      return {
        mediaType,
        img: mediaType === 'image' ? item?.img || '' : '',
        video: mediaType === 'video' ? item?.video || '' : '',
        showIcon: item?.showIcon !== false,
        icon: item?.icon || '',
        previewTick: Number(item?.previewTick) || 0,
      };
    });
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardMultiTool(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeRatingStars(value) {
      this.fields.reted.ratingStars = value;
    },
    handleChangeTextColor(event) {
      this.fields.textColor = event.target.value;
    },
    handleChangeRatingTextColor(event) {
      this.fields.reted.ratingTextColor = event.target.value;
    },
    handleChangeCardContainer(event) {
      this.fields['background-section'].color = event.target.value;
    },
    handleChangeButtonBackground(event) {
      this.fields.btnCard.backgroundColor = event.target.value;
    },
    handleChangeButtonTextColor(event) {
      this.fields.btnCard.color = event.target.value;
    },
    handleChangePosition(value) {
      // 1 => image left (order 1), 2 => image right (order 2)
      if (value === 1) {
        this.fields.rightCard.order = '1';
        this.fields.leftCard.order = '2';
      } else {
        this.fields.rightCard.order = '2';
        this.fields.leftCard.order = '1';
      }
    },
    handleUploadRightCardImage(obj) {
      this.fields.rightCard.mediaType = 'image';
      this.fields.rightCard.img = obj.imageSrc;
      this.fields.rightCard.video = '';
    },
    handleRemoveRightCardImage() {
      this.fields.rightCard.img = '';
    },
    handleChangeMediaType(value) {
      this.fields.rightCard.mediaType = value === 'image' ? 'image' : 'video';
      if (this.fields.rightCard.mediaType === 'image') {
        this.fields.rightCard.video = '';
      } else {
        this.fields.rightCard.img = '';
      }
    },
    handleChangeRightCardVideo(value) {
      this.fields.rightCard.mediaType = 'video';
      this.fields.rightCard.video = value || '';
      this.fields.rightCard.img = '';
    },
    handleAddImageSmall() {
      this.fields['images-small'].listItem.push({
        mediaType: 'image',
        img: '',
        video: '',
        showIcon: true,
        icon: '',
        previewTick: 0,
      });
    },
    handleUploadImageSmall(obj, index) {
      const item = this.fields['images-small'].listItem[index];
      item.mediaType = 'image';
      item.img = obj.imageSrc;
      item.video = '';
    },
    handleRemoveImageSmall(index) {
      this.fields['images-small'].listItem.splice(index, 1);
    },
    handleChangeImageSmallMediaType(value, index) {
      const item = this.fields['images-small'].listItem[index];
      item.mediaType = value === 'video' ? 'video' : 'image';
      if (item.mediaType === 'video') {
        item.img = '';
      } else {
        item.video = '';
      }
    },
    handleUpdateImageSmallVideo(value, index) {
      const item = this.fields['images-small'].listItem[index];
      item.mediaType = 'video';
      item.video = value || '';
      item.img = '';
    },
    handleRefreshImageSmallVideo(index) {
      const item = this.fields['images-small'].listItem[index];
      if (!item) return;
      item.previewTick = (Number(item.previewTick) || 0) + 1;
    },
    handleClearImageSmallMedia(index) {
      const item = this.fields['images-small'].listItem[index];
      if (!item) return;
      item.img = '';
      item.video = '';
    },
    handleToggleImageSmallIcon(value, index) {
      const item = this.fields['images-small'].listItem[index];
      item.showIcon = value !== false;
      if (!item.showIcon) item.icon = '';
    },
    handleUploadImageSmallIcon(obj, index) {
      this.fields['images-small'].listItem[index].icon = obj.imageSrc;
    },
    handleRemoveImageSmallIcon(index) {
      this.fields['images-small'].listItem[index].icon = '';
    },
    handleAddItemWithIcon() {
      this.fields.itemWithIcon.listItem.push({ icon: '', title: '', description: '' });
    },
    handleRemoveItemWithIcon(index) {
      this.fields.itemWithIcon.listItem.splice(index, 1);
    },
    handleUploadItemWithIcon(obj, index) {
      this.fields.itemWithIcon.listItem[index].icon = obj.imageSrc;
    },
    handleRemoveItemWithIconIcon(index) {
      this.fields.itemWithIcon.listItem[index].icon = '';
    },
    handleAddAccordion() {
      this.fields.itemAccordions.listItem.push({ title: '', answer: '' });
    },
    handleRemoveAccordion(index) {
      this.fields.itemAccordions.listItem.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
::v-deep .ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.img-small-item {
  position: relative;
}
.img-small-delete {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #fff;
  border-radius: 50%;
}
.img-small-item-card {
  border: 1px solid #ececec;
  border-radius: 8px;
  padding: 8px;
}
.img-small-item-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: space-between;
}
.video-small-preview {
  margin-top: 8px;
}
.video-small-preview video {
  max-height: 150px;
  border-radius: 6px;
  background: #000;
}
</style>
